import React from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ValidationMessage } from "../../../components/Utils";

export const buildUpiPreviewUrl = (form) => {
  if (!form?.payee_upi_id || !form?.payee_name || !form?.payment_amount) return "";
  const params = new URLSearchParams({
    pa: String(form.payee_upi_id).trim(),
    pn: String(form.payee_name).trim(),
    am: Number(form.payment_amount).toFixed(2),
    cu: form.payment_currency || "INR",
  });
  return `upi://pay?${params.toString()}`;
};

const upiIdTooltip = (
  <Tooltip id="payee-upi-id-tooltip">
    <div className="text-start">
      <strong>Google Pay:</strong> Profile → UPI IDs → copy your UPI ID (e.g. name@okaxis)
      <br />
      <br />
      <strong>PhonePe:</strong> Profile → Payment Methods → UPI ID (e.g. name@ybl)
    </div>
  </Tooltip>
);

const EventUpiPaymentSection = ({
  form,
  setForm,
  errors,
  showQrPreview = false,
}) => {
  const upiPreviewUrl = buildUpiPreviewUrl(form);

  return (
    <div className="col-12">
      <div className="event-upi-section">
        <div className="event-upi-section-header">
          <i className="bx bx-qr event-upi-section-icon" aria-hidden="true" />
          <div>
            <h6 className="event-upi-section-title">UPI Payment Details</h6>
            <p className="event-upi-section-subtitle mb-0">
              QR code is generated automatically from these details on save.
            </p>
          </div>
        </div>

        <div className="row event-upi-row-paired">
          <div className="col-md-6">
            <div className="mb-3 event-upi-field">
              <label
                htmlFor="payee_upi_id"
                className="form-label event-upi-field-label"
              >
                <span>
                  Payee Address (Merchant UPI ID)
                  <span className="text-danger">*</span>
                </span>
                <OverlayTrigger placement="top" overlay={upiIdTooltip}>
                  <i
                    className="bx bx-info-circle event-upi-info-icon"
                    role="img"
                    aria-label="How to find UPI ID in Google Pay or PhonePe"
                  />
                </OverlayTrigger>
              </label>
              <small className="event-upi-field-hint">
                Find in GPay: Profile → UPI IDs | PhonePe: Profile → Payment
                Methods → UPI ID
              </small>
              <input
                type="text"
                className="form-control"
                id="payee_upi_id"
                placeholder="merchant@upi"
                value={form?.payee_upi_id || ""}
                onChange={(e) =>
                  setForm({ ...form, payee_upi_id: e.target.value })
                }
              />
              <ValidationMessage error={errors} name="payee_upi_id" />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3 event-upi-field event-upi-field-above-input">
              <label htmlFor="payee_name" className="form-label event-upi-field-label">
                Payee Name
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="payee_name"
                placeholder="ABC Store"
                value={form?.payee_name || ""}
                onChange={(e) =>
                  setForm({ ...form, payee_name: e.target.value })
                }
              />
              <ValidationMessage error={errors} name="payee_name" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="payment_amount" className="form-label">
                Amount to be paid
                <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                step="0.01"
                min="0.01"
                className="form-control"
                id="payment_amount"
                placeholder="100.00"
                value={form?.payment_amount ?? ""}
                onChange={(e) =>
                  setForm({ ...form, payment_amount: e.target.value })
                }
              />
              <ValidationMessage error={errors} name="payment_amount" />
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-3">
              <label htmlFor="payment_currency" className="form-label">
                Currency
              </label>
              <input
                type="text"
                className="form-control"
                id="payment_currency"
                value="INR"
                disabled
                readOnly
              />
            </div>
          </div>

          {upiPreviewUrl && (
            <div className="col-12">
              <div className="event-upi-preview mb-3">
                <label className="form-label m-0">UPI Payment URL</label>
                <span className="d-block small text-muted text-break">
                  {upiPreviewUrl}
                </span>
                {!showQrPreview && (
                  <span className="d-block small mt-1 text-muted">
                    QR code will be generated automatically on save.
                  </span>
                )}
              </div>
            </div>
          )}

          {showQrPreview && form?.qrImage && (
            <div className="col-12">
              <div className="event-upi-preview mb-0">
                <label className="form-label m-0">Generated QR Code</label>
                <div className="m-2">
                  <Image width={120} height={120} src={form.qrImage} />
                </div>
                <span className="d-block small text-muted">
                  QR code will be regenerated when you save changes.
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventUpiPaymentSection;
